export default "__VITE_ASSET__BOfLyB39__"